export default {
  query_getTotalByDay: {
    type: "formDataPost"
  },
  query_getBankDealing: {
    type: "formDataPost"
  },
  query_getZhexiantuByDay: {
    type: "formDataPost"
  },
  query_getZhexiantuByMonth: {
    type: "formDataPost"
  },
  query_getZhexiantuDetailByDay: {
    type: "formDataPost"
  },
  query_getZhexiantuDetailByMonth: {
    type: "formDataPost"
  },
  query_getZhexiantuDetailByList: {
    type: "formDataPost"
  },
  receivePay_receivePayStatistics: {
    type: "formDataPost"
  },
  receivePay_getLineChartData: {
    type: "formDataPost"
  },
  receivePay_getLineChartByPage: {
    type: "formDataPost"
  },
  receivePay_getLineChartDetail: {
    type: "formDataPost"
  },
  receivePay_exportLineChartData: {
    type: "get"
  },
  receivePay_exportLineChartDetail: {
    type: "get"
  },
  merchant_request_selectUrlNameMap: {
    type: "formDataPost"
  },
  merchant_request_select: {
    type: "post"
  },
  merchant_request_selectSingleMethod: {
    type: "post"
  }
};



// WEBPACK FOOTER //
// ./src/service/modules/dataChart.js